import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";

import { BaseEntityController } from "../baseEntityController";
import { LocalCacheService } from "../../services/local-cache-service";
import { UsageService } from "../../services/usage-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { AclService } from "../../services/acl-service";
import { EventService } from "../../services/event-service";

export class UsagesController extends BaseEntityController {
    static $inject = ["$scope", "$rootScope", "$q", "$window", "usageService", "localCacheService", "notifyService", "entityService", "aclService", "eventService"];

    entityID: string;
    templateID: string;
    forceRefresh: boolean;

    asset: Models.IEntityCharDataPair;
    charTypeID: number;

    editParentCurrencyCharData: Models.ICharDataValue;

    editAssetCharDataCollection: Models.ICharDataCollection;                // chardata for editing usages/amounts under assets
    editAssetModalOpen: boolean;                                            // modal for editing usages/amounts under assets
    editAssetModalTitle: string;                                            // modal title for editing usages/amounts under assets
    editAssetModalMode: string;                                             // switches save button mode on edit usage/amount modal
    editAssetModalParentID: string;

    locked: number;
    canEdit: boolean;
    visibility: number;
    initialized: boolean;

    selectedUsages: { [templateID: number]: Models.IUsageRelationshipPair[] };
    dataDefaultTemplateID: number = -1;
    dataDefaultLabel: string = "";
    showSaveDefaultsModal: boolean = false;
    selectedEntities: Models.IEntity[];
    newDataDefaultSetEntityIDs: string[];

    currentUsageTemplateIds: number[];
    canCopy: boolean;
    //--

    constructor(
        $scope: ng.IScope,
        private $rootScope: ng.IRootScopeService,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        private usageService: UsageService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        entityService: EntityService,
        private aclService: AclService,
        private eventService: EventService) {

        super($scope, $q, entityService, localStorage, notifyService);

        this.charTypeID = 0;
        this.locked = 1;
        this.initialized = false;
        this.newDataDefaultSetEntityIDs = [];

        this.canCopy = false;
        //--

        $scope.$watch(() => {
            if (this.entityID == null) {
                return null;
            } else {
                return this.entityID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.RefreshParent();
                    });
                }
            });
    }

    Init(entityID: string) {
        this.entityID = entityID;

        //Get the chartype of the base entity and see if we can edit Tables on that chartype
        this.aclService.loadActivityAcls()
            .then((acls) => {
                switch (Utils.IdBuilder.splitEntityID(this.entityID).charTypeID) {
                    case Consts.CharTypeIDs.user:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod2.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod2);
                        break;
                    case Consts.CharTypeIDs.project:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod16.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod16);
                        break;
                    case Consts.CharTypeIDs.property:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod1.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
                        break;
                    case Consts.CharTypeIDs.transaction:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
                        break;
                    case Consts.CharTypeIDs.inventory:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod17.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod17);
                        break;
                    case Consts.CharTypeIDs.job:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod15.Usages);
                        this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod15);
                        break;
                }
            });

        this.notifyService.startProgress();
        this.charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
        this.entityService.getEntity(entityID)
            .then((res) => {
                this.asset = res;
                this.templateID = Utils.IdBuilder.buildTemplateID(res.record.divisionID, this.charTypeID, res.charDataCollection.templateMetaData.templateID);
                this.editParentCurrencyCharData = Utils.CharUtil.GetCurrencyCharData(res.charDataCollection);
                this.locked = res.charDataCollection.status.lockIndicator;
                this.entity = res.record;
                if (!this.wasValidated) {
                    this.Validate();
                }

                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Refresh(): ng.IPromise<any> {
        this.forceRefresh = true;
        return this.$q.resolve();
    }

    /*
     * Open create usage modal
     * @param asset asset (entity+chardata+relationship+usages)
     * @param template template of new usage
     * @param $event  event for cancelling <a> click
     */
    NewUsage(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        $event.preventDefault();

        var templateID = Utils.IdBuilder.buildTemplateID(this.asset.record.divisionID, Consts.CharTypeIDs.usage, template.templateID);

        this.notifyService.startProgress();
        this.entityService.getEmptyEntityCharData(templateID)
            .then((result) => {
                this.selectedEntities = [];
                this.editAssetCharDataCollection = result;
                this.editAssetModalParentID = this.asset.record.id;
                // if there are visible CMDs to edit, show the edit modal
                if (this.CountVisibleChars(this.editAssetCharDataCollection) > 0) {
                    this.editAssetModalTitle = "New " + template.templateName;
                    this.editAssetModalMode = "create_usage";
                    this.editAssetModalOpen = true;
                } else {
                    // else just save the usage
                    return this.CreateUsage(true);
                }

                if (this.currentUsageTemplateIds.indexOf(template.templateID) === -1) {
                    this.currentUsageTemplateIds.push(template.templateID);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    CountVisibleChars(charDataCollection: Models.ICharDataCollection): number {
        if (charDataCollection != null) {
            return Utils.AclUtil.filterCMDsByRights(this.aclService.acls, charDataCollection.templateMetaData, Consts.AccessRight.Read).length;
            //return _(charDataCollection.templateMetaData.characteristicMetaDatas).filter((cmd) => cmd.visibilityIndicator >= this.visibility).valueOf().length;
        }
        return 0;
    }

    private saveRelationships(relationship: Models.IEntityRelationship) {
        if (this.selectedEntities.length > 0) {
            this.notifyService.startProgress();
            return this.entityService.createEntityRelationships(
                Utils.IdBuilder.buildRelationshipID(relationship),
                _.map(this.selectedEntities, (entity) => {
                    return entity.id;
                }))
                .finally(() => {
                    this.selectedEntities = [];
                    this.notifyService.endProgress();
                });
        }
    }

    CreateUsage(isValid: boolean) {
        if (isValid) {
            // build full template
            var templateID = Utils.IdBuilder.buildTemplateID(this.editAssetCharDataCollection.templateMetaData.divID, Consts.CharTypeIDs.usage, this.editAssetCharDataCollection.templateMetaData.templateID);
            var charDatas = this.editAssetCharDataCollection.charDatas;
            var parentID = this.editAssetModalParentID;
            this.notifyService.startProgress();
            return this.entityService.createEntity(templateID, parentID, charDatas)
                .then((result) => {
                    if (result) {
                        this.notifyService.notifySuccess("Usage Created");
                    } else {
                        this.notifyService.notifyError("Error creating Usage");
                    }

                    // if entities were selected to create new relationships let's save them now
                    if (this.selectedEntities.length > 0) {
                        var newEntityID = Utils.IdBuilder.splitEntityID(result.entityID);

                        this.entityService.getEntityRelationships(this.entityID, newEntityID.charTypeID)
                            .then((res) => {
                                var newRelationships = _.filter(res, (relationship) => {
                                    return relationship.childRecID == newEntityID.recID;
                                });
                                if (newRelationships.length === 1) {
                                    this.saveRelationships(newRelationships[0])
                                        .then((res) => {
                                            this.forceRefresh = true;
                                        });
                                }

                            });
                    } else {
                        this.forceRefresh = true;
                    }
                })
                .then(() => {
                    this.editAssetModalOpen = false;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    ToggleSelectUsage(usage: Models.IUsageRelationshipPair) {
        var index = this.selectedUsages[usage.record.templateID].indexOf(usage);
        if (index > 0) {
            this.selectedUsages[usage.record.templateID].splice(index, 1);
        } else {
            this.selectedUsages[usage.record.templateID].push(usage);
        }
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    Delete() {
        var listUrl: string = "";
        var charTypeName: string = "";
        switch (Utils.IdBuilder.splitEntityID(this.entityID).charTypeID) {
            case Consts.CharTypeIDs.user:
                listUrl = Consts.Urls.ContactListPage;
                charTypeName = "Contact";
                break;
            case Consts.CharTypeIDs.project:
                listUrl = Consts.Urls.ProjectListPage;
                charTypeName = "Project";
                break;
            case Consts.CharTypeIDs.property:
                listUrl = Consts.Urls.PropertyListPage;
                charTypeName = "Catalog Item";
                break;
            case Consts.CharTypeIDs.transaction:
                listUrl = Consts.Urls.ContractListPage;
                charTypeName = "Deal";
                break;
            case Consts.CharTypeIDs.inventory:
                listUrl = Consts.Urls.InventoryListPage;
                charTypeName = "Inventory";
                break;
            case Consts.CharTypeIDs.job:
                listUrl = Consts.Urls.JobListPage;
                charTypeName = "Job";
                break;
        }

        if (this.$window.confirm("Are you sure you want to delete this " + charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + charTypeName + "?")) {
            this.notifyService.startProgress();


            this.entityService.deleteEntity(this.entityID)
                .then(() => {
                    this.$window.location.assign(listUrl);
                },
                    () => {
                        this.notifyService.notifyError("Error Deleting " + charTypeName);
                    })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshParent() {
        this.entityService.getEntity(this.entityID)
            .then((result) => {
                this.locked = result.charDataCollection.status.lockIndicator;
            });
    }
}
